module.exports = __webpack_public_path__ + "media/images/footer/pl_ef-373d860767b77128690fe9db45a37d03.svg";